/** @jsxImportSource @emotion/react */
import NovaventaButton from "@/components/formControls/button/NovaventaButton";
import CheckboxTC from "@/components/formControls/CheckBoxTC";
import InformationBox from "@/components/InformationBox/InformationBox";
import { usePrismic } from "@/hooks/usePrismic";
import novaTheme from "@/styles/novaTheme";
import { css } from "@emotion/react";
import { Modal } from "antd";
import type { RichTextBlock } from "prismic-reactjs";
import { RichText } from "prismic-reactjs";
import type { ChangeEvent } from "react";
import { useState } from "react";

type Props = {
  hide?: boolean;
  termAnConditionsText?: RichTextBlock[];
};

const TermsAndConditions = ({ hide, termAnConditionsText }: Props) => {
  const t = usePrismic();
  const [visible, setVisible] = useState(hide);
  const [accepted, setAccepted] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleAccepted = (e: ChangeEvent<HTMLInputElement>) => {
    setAccepted(e.target.checked);
    setIsError(!e.target.checked);
  };

  const handleContinue = () => {
    if (accepted) setVisible(false);
    else setIsError(true);
  };

  return (
    <Modal
      open={visible}
      closable={false}
      maskClosable={false}
      footer={null}
      style={{ top: 20 }}
      width={{
        xs: "96%",
        sm: "90%",
        md: "80%",
        lg: "70%",
        xl: "60%",
        xxl: "50%"
      }}
      title={
        <h1
          css={{
            fontSize: "1.5em",
            color: novaTheme.colors.blue400,
            fontWeight: 500,
            fontFamily: novaTheme.fonts.ProximaNovaLight
          }}
        >
          {t.constants.TERMCONDICION}
        </h1>
      }
    >
      <div css={{ maxHeight: "60vh", overflowY: "scroll" }}>
        <RichText render={termAnConditionsText} />
      </div>
      <div>
        <CheckboxTC
          text={t.constants.ACEPTARLOS}
          boldTex={t.constants.TERMCONDICION}
          onChangeCheck={handleAccepted}
          check={accepted}
        />
      </div>
      <InformationBox hide={isError} text={t.constants.DEBESACEPTAR} kind="alert" />
      <div
        css={css`
          .ant-btn {
            margin: 1rem;
            width: 3rem;
            height: 3rem;
          }
        `}
      >
        <NovaventaButton showArrow={true} handleClick={handleContinue} />
      </div>
    </Modal>
  );
};

export default TermsAndConditions;
